import {
  USER_SEARCH_SUCCESS,
  USER_SEARCH_ERROR,
  USER_PAYPAL_INFO_SUCCESS,
  USER_PAYPAL_INFO_FAILURE
} from '../constants';
import axios from 'axios';

export const searchByDisplayName = (searchValue, isInfluencerSearch) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();

    try {
      const idToken = await firebase.auth().currentUser.getIdToken(true);

      const userResponse = await axios.post(
        `${process.env.REACT_APP_FIREBASE_URL}/searchDisplayName`,
        {
          idToken,
          searchValue,
          isInfluencerSearch
        }
      );

      dispatch({
        type: USER_SEARCH_SUCCESS,
        payload: [...userResponse.data]
      });
    } catch (err) {
      return dispatch({
        type: USER_SEARCH_ERROR,
        payload: { err }
      });
    }
  };
};

export const updateProfile = newProfileData => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .updateProfile({ ...newProfileData })
      .then(() => {})
      .catch(err => {});
  };
};

export const updatePaypalInfo = paypalInfo => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .updateProfile({ paypalInfo })
      .then(() => {
        return dispatch({
          type: USER_PAYPAL_INFO_SUCCESS,
          payload: {}
        });
      })
      .catch(err => {
        return dispatch({
          type: USER_PAYPAL_INFO_FAILURE,
          payload: {}
        });
      });
  };
};

export const deleteAccount = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(idToken => {
        axios
          .post(`${process.env.REACT_APP_FIREBASE_URL}/deleteUser`, {
            idToken
          })
          .then(response => {
            if (response.status == 400) {
              // did not delete user
            } else if (response.status == 500) {
              // did not delete user
            } else {
              firebase.auth().signOut();
            }
            // successfully deleted
          })
          .catch(err => {
            const gg = err;
          });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/userProfileActions.js